module.exports = __webpack_public_path__ + "media/common/fonts/streamline-large/streamline-large-992c0a27843ece60db339bb1176b3a59.ttf";